module.exports = __webpack_public_path__ + "static/media/manageCountries.e376c7be.svg";